import React from "react";
import {
  GridItem,
  GridContainer,
  AddTerminalContainer,
} from "./MerchantAndTerminals.styles";
import TextField from "../../textField/TextField";
import SelectField from "../../selectField/SelectField";
import { Box, Typography, IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";

import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";

const TerminalsFields = ({
  formValues,
  handleChange,
  handleBlur,
  handleTerminalChange,
  handleDeleteTerminal,
  handleAddTerminal,
  errors,
  touched,
  setSeverity,
  setMessageOpen,
  setSnackOpen,
  readOnly = false,
}) => {
  const {
    acquirer: {
      terminal: { terminals },
    },
  } = formValues;

  const terminalTypeOptions = [
    { value: "A", label: "ATM = A" },
    { value: "C", label: "COTS (Phone/Tablet) = C" },
    { value: "E", label: "eCommerce = E" },
    { value: "R", label: "ECR = R" },
    { value: "I", label: "App = I" },
    { value: "K", label: "Kiosk = K" },
    { value: "M", label: "mPOS = M" },
    { value: "P", label: "POS = P" },
    { value: "T", label: "Teller = T" },
    { value: "V", label: "Vending Machine = V" },
  ];

  const sanitizeNoSpaceValue = (value) => value.replace(/\s+/g, "");

  const handleTerminalFieldChange = (index, field, value) => {
    handleTerminalChange(index, field, sanitizeNoSpaceValue(value));
  };

  const handleAddTerminalClick = () => {
    // if (terminals.length >= 10) {
    //   setSeverity("warning");
    //   setMessageOpen("Maximum 10 terminals allowed");
    //   setSnackOpen(true);
    //   return;
    // }
    handleAddTerminal();
  };

  return (
    <>
      <GridContainer>
        {terminals.map((terminal, index) => (
          <GridItem xs={12} sm={12} lg={6} key={index} padding="0 10px">
            <Box
              key={index}
              sx={{ mb: 3, p: 2, border: 1, borderColor: "divider", borderRadius: 1 }}
            >
              <Box
                display="flex"
                alignItems="center"
                justifyContent="space-between"
                mb={2}
              >
                <Typography variant="h6" color="primary">
                  Terminal {index + 1}
                </Typography>
                {!readOnly && terminals.length > 1 && (
                  <Tooltip title="Delete Terminal" arrow>
                    <IconButton
                      color="error"
                      onClick={() => handleDeleteTerminal(index)}
                      disabled={readOnly}
                    >
                      <DeleteIcon />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>

              <GridContainer>
                <GridItem xs={12} md={6} padding="0 15px 15px 0">
                  <TextField
                    id={`acquirer.terminal.terminals.${index}.terminalSerial`}
                    name={`acquirer.terminal.terminals.${index}.terminalSerial`}
                    fullWidth
                    label="Terminal Serial"
                    value={terminal.terminalSerial || ""}
                    onChange={(e) =>
                      handleTerminalFieldChange(
                        index,
                        "terminalSerial",
                        e.target.value
                      )
                    }
                    onBlur={handleBlur}
                    required
                    maxLength={30}
                    inputProps={{ pattern: "\\S*" }}
                    error={
                      errors.acquirer?.terminal?.terminals?.[index]
                        ?.terminalSerial
                    }
                    touched={
                      touched.acquirer?.terminal?.terminals?.[index]
                        ?.terminalSerial
                    }
                    disabled={readOnly}
                    helperText="Terminal serial number"
                  />
                </GridItem>
                <GridItem xs={12} md={6} padding="0 15px 15px 0">
                  <SelectField
                    id={`acquirer.terminal.terminals.${index}.terminalType`}
                    name={`acquirer.terminal.terminals.${index}.terminalType`}
                    fullWidth
                    label="Terminal Type"
                    value={terminal.terminalType || ""}
                    options={terminalTypeOptions}
                    required
                    onChange={(e) =>
                      handleTerminalChange(
                        index,
                        "terminalType",
                        e.target.value
                      )
                    }
                    onBlur={handleBlur}
                    error={
                      errors.acquirer?.terminal?.terminals?.[index]
                        ?.terminalType
                    }
                    touched={
                      touched.acquirer?.terminal?.terminals?.[index]
                        ?.terminalType
                    }
                    disabled={readOnly}
                    helperText="Type of terminal"
                  />
                </GridItem>
              </GridContainer>
            </Box>
          </GridItem>
        ))}

        {!readOnly && (
          <GridContainer>
            <AddTerminalContainer xs={12} padding="0 10px">
              <Box sx={{ "& > :not(style)": { m: 1 } }}>
                <Fab
                  color="primary"
                  variant="extended"
                  onClick={handleAddTerminalClick}
                  disabled={readOnly}
                >
                  <AddIcon sx={{ mr: 1 }} />
                  Add Terminal
                </Fab>
              </Box>
            </AddTerminalContainer>
          </GridContainer>
        )}

        {/* {!readOnly && (
          <Box textAlign="center" mt={1}>
            <Typography variant="caption" color="textSecondary">
              Click to add terminal (Max: 10)
            </Typography>
          </Box>
        )} */}
      </GridContainer>
    </>
  );
};

export default TerminalsFields;
